import Phaser from 'phaser';
import { GAME_CONFIG, WORLDS } from '../config/game';
import { GameStateManager } from '../managers/GameStateManager';

export class WorldMapScene extends Phaser.Scene {
  constructor() {
    super('WorldMapScene');
  }

  create() {
    const { width, height } = GAME_CONFIG;

    // Background
    this.add.rectangle(width / 2, height / 2, width, height, 0x1a1a2e);

    // Title
    this.add.text(width / 2, 30, 'WORLD MAP', {
      fontFamily: 'Georgia, serif',
      fontSize: '24px',
      color: '#ffd700',
    }).setOrigin(0.5);

    // Create level list
    let yPos = 80;

    for (const world of WORLDS) {
      const isWorldUnlocked = GameStateManager.isWorldUnlocked(world.id);
      
      // World header
      this.add.text(20, yPos, `WORLD ${world.id}: ${world.name}`, {
        fontFamily: 'Georgia, serif',
        fontSize: '16px',
        color: isWorldUnlocked ? '#ffd700' : '#555555',
        fontStyle: 'bold',
      });
      yPos += 25;

      // Only show levels for unlocked worlds
      if (isWorldUnlocked) {
        for (const level of world.levels) {
          const isUnlocked = GameStateManager.isLevelUnlocked(level.id);
          const isCompleted = GameStateManager.isLevelCompleted(level.id);
          
          // Level button background
          const btnColor = isCompleted ? 0x1a4a1a : (isUnlocked ? 0x2a2a4a : 0x1a1a2e);
          const btn = this.add.rectangle(width / 2, yPos + 20, width - 40, 45, btnColor);
          btn.setStrokeStyle(2, isCompleted ? 0x22c55e : (isUnlocked ? 0xffd700 : 0x333333));

          // Level text
          this.add.text(35, yPos + 10, `${level.id} - ${level.name}`, {
            fontFamily: 'Georgia, serif',
            fontSize: '13px',
            color: isUnlocked ? '#ffffff' : '#555555',
          });

          // Type badge
          this.add.text(width - 35, yPos + 10, level.type, {
            fontFamily: 'Georgia, serif',
            fontSize: '10px',
            color: isUnlocked ? '#88ff88' : '#555555',
          }).setOrigin(1, 0);

          // Status
          if (isCompleted) {
            this.add.text(width - 35, yPos + 25, '✓ Complete', {
              fontSize: '10px',
              color: '#22c55e',
            }).setOrigin(1, 0);
          } else if (!isUnlocked) {
            this.add.text(width - 35, yPos + 20, '🔒', {
              fontSize: '16px',
            }).setOrigin(1, 0.5);
          }

          // Make clickable
          if (isUnlocked) {
            btn.setInteractive({ useHandCursor: true });
            btn.on('pointerover', () => btn.setFillStyle(0x3a3a6a));
            btn.on('pointerout', () => btn.setFillStyle(btnColor));
            btn.on('pointerdown', () => this.startLevel(level.id));
          }

          yPos += 50;
        }
      } else {
        this.add.text(35, yPos, '🔒 Complete previous world', {
          fontSize: '12px',
          color: '#555555',
        });
        yPos += 25;
      }
      
      yPos += 15; // Gap between worlds
    }

    // Back button
    const backBtn = this.add.text(width / 2, height - 40, '← Back to Title', {
      fontFamily: 'Georgia, serif',
      fontSize: '14px',
      color: '#a78bfa',
    }).setOrigin(0.5);
    backBtn.setInteractive({ useHandCursor: true });
    backBtn.on('pointerover', () => backBtn.setColor('#ffffff'));
    backBtn.on('pointerout', () => backBtn.setColor('#a78bfa'));
    backBtn.on('pointerdown', () => this.scene.start('TitleScene'));

    // Fade in
    this.cameras.main.fadeIn(300, 0, 0, 0);
  }

  private startLevel(levelId: string) {
    GameStateManager.setCurrentLevel(levelId);
    const sceneKey = GameStateManager.getLevelSceneKey(levelId);

    this.cameras.main.fadeOut(300, 0, 0, 0);
    this.time.delayedCall(300, () => {
      const implementedScenes = ['BlanketBossScene', 'ClothesChaoScene', 'MissingShoeScene', 'MorningTitanScene'];
      this.scene.start(implementedScenes.includes(sceneKey) ? sceneKey : 'HouseScene');
    });
  }
}
